import { lazy } from 'react';

const TweetAudit = lazy(() => import('pages/tweetAudit'));

const TweetDetail = lazy(() => import('pages/tweetDetail'));

const TweetManage = lazy(() => import('pages/tweetManage'));

export const router = {
    path: '/tweet',
    name: '推文管理',
    permission: 110,
    icon: 'pic-left',
    children: [
        {
            path: 'tweetAudit',
            name: '推文审核',
            icon: 'pic-left',
            permission: 11001,
            component: TweetAudit,
        },
        {
            path: 'tweetManage',
            name: '推文管理',
            icon: 'pic-left',
            permission: 11002,
            component: TweetManage,
        },
        {
            path: 'tweetDetail',
            name: '推文详情',
            hideInMenu: true,
            icon: 'book',
            permission: 11001,
            component: TweetDetail,
        },
        {
            path: 'tweetDetail',
            name: '推文详情',
            hideInMenu: true,
            icon: 'book',
            permission: 11002,
            component: TweetDetail,
        },
    ],
};

export default router;
